import { View, Text, TouchableOpacity, TextInput, StyleSheet, Linking } from 'react-native';
//import { useNavigation } from '@react-navigation/native';
import { useNavigate } from 'react-router-dom';
import NavBar from './navBar';
import React, { useState , useEffect} from 'react';
import MenuPanel from './menuPanel';
const ContactPage = () => {
  //const navigation = useNavigation();
const navigate = useNavigate();
  const [menuVisible, setMenuVisible] = useState(false);
  const [confirmEmailSendVisible, setConfirmEmailSendVisibleVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);
  useEffect(() => {
    // Reimposta confirmEmailSendVisible a false ogni volta che la pagina viene caricata
    setConfirmEmailSendVisibleVisible(false);
  }, []);
  const TestMailCheckout = async () => {
    console.log('email: '+  shippingData.email + ' nmessage '+  shippingData.message);
        try {
          const message = `Email-Cliente: ${String(shippingData.email)} Message: ${String(shippingData.message)}`;
   
          const response = await fetch('/sendEmailForInfo.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              subject: 'Informazioni',
              message:  message,
            }),
          });
      
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
      
          setConfirmEmailSendVisibleVisible(true);
          setShippingData((prevState) => ({ ...prevState, 
            message: ' ', 
          }));
         console.error('Email inviata con successo' );
        } catch (error) {
          console.error('Errore nell\'invio dell\'email:', error);
         
        }
      };

      const [shippingData, setShippingData] = useState({
        email: '',
        message: '',
      });
    
      const handleInputChange = (field, value) => {
        setShippingData(prevData => {
          const updatedData = { ...prevData, [field]: value };
          const allFieldsFilled = Object.values(updatedData).every(fieldValue => fieldValue.trim() !== '');
          return updatedData;
        });
      };

  return (  <View style={styles.container}>
    {/* NavBar with Menu Button */}
    <NavBar toggleMenu={toggleMenu} />

    {/* Side Menu */}
    <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />

      <View style={styles.header}>
        <Text style={styles.headerText}>Contattaci</Text>
      </View>

      <View style={styles.contactContainer}  >
      {confirmEmailSendVisible && (
    <Text style={styles.phoneText}>
      Messaggio inviato con successo con mail: ${String(shippingData.email)}
    </Text>
    
  )}

        <Text style={styles.contactTitle}>Inviaci un messaggio</Text>
        
        <TextInput
          style={styles.input}
          placeholder="Email"
          placeholderTextColor="#888"
          onChangeText={text => handleInputChange('email', text)}
        />
        <TextInput
          style={styles.input}
          placeholder="Messaggio"
          placeholderTextColor="#888"
          multiline
          numberOfLines={4}
          onChangeText={text => handleInputChange('message', text)}
        />

        <TouchableOpacity style={styles.contattaciButton} onPress={TestMailCheckout}>
          <Text style={styles.contattaciText}>Contattaci</Text>
        </TouchableOpacity>
      </View>
     

      {/* Sezione informazioni aggiuntive */}
      <View style={styles.infoSection}>
        <Text style={styles.infoTitle}>Orari di Disponibilità</Text>
        <Text style={styles.infoText}>Siamo disponibili dalle 9:00 alle 18:00, dal lunedì al venerdì.</Text>

        <Text style={styles.infoTitle}>Tempi di Risposta</Text>
        <Text style={styles.infoText}>Risponderemo a tutte le richieste entro 24 ore lavorative.</Text>
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>Oppure scrivici direttamente alla mail: </Text>
        <Text style={styles.phoneText}>neveroutshop@gmail.com</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flex: 1,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
  },
  header: {
    marginTop: 60,
    padding:10,
    alignItems: 'center',
    marginBottom: 30,
  },
  headerText: {
    fontSize: 30,
    fontWeight: 'bold',
    color: '#333',
  },
  contactContainer: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 20,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 2 },
    elevation: 5,
  },
  contactTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  input: {
    height: 45,
    borderColor: '#ddd',
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 15,
    paddingLeft: 10,
    fontSize: 16,
    backgroundColor: '#fafafa',
  },
  whatsappButton: {
    backgroundColor: '#25D366', // Colore di WhatsApp
    borderRadius: 5,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  whatsappText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  infoSection: {
    marginTop: 30,
    paddingHorizontal: 10,
    paddingVertical: 20,
    backgroundColor: '#fff',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 2 },
    elevation: 5,
  },
  infoTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 5,
  },
  infoText: {
    fontSize: 16,
    color: '#666',
    marginBottom: 15,
  },
  footer: {
    marginTop: 20,
    alignItems: 'center',
  },
  footerText: {
    fontSize: 16,
    color: '#333',
  },
  phoneText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#25D366', // Colore di WhatsApp
  },
  contattaciButton: {
    backgroundColor: '#000', // Colore di WhatsApp
    borderRadius: 5,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contattaciText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
});

export default ContactPage;
